// src/lib/infra.ts — static deploy/region/service facts for the admin infra
// panel. Mirrors values from gbl.config.yaml (kept in sync manually for v0.8.0).
// TODO(v0.9.0): hook into Cloud Run health endpoints for live status instead of
// these static values.

export interface InfraFact {
  label: string;
  value: string;
}

export const INFRA_FACTS: InfraFact[] = [
  { label: "App", value: "PULSE (pulse)" },
  { label: "GCP project", value: "pulse-goodbetter" },
  { label: "Region", value: "us-central1" },
  { label: "Cloud SQL", value: "pulse-goodbetter:us-central1:pulse-db" },
  { label: "Prod domain", value: "pulse.goodbetter.llc" },
  { label: "lifesuite-infra", value: "v1.0.0" },
  { label: "Service version", value: "v0.8.0" },
];

export interface QuickLink {
  label: string;
  href: string;
}

export const QUICK_LINKS: QuickLink[] = [
  { label: "GitHub — PULSE repo", href: "https://github.com/GoodBetterLLC/pulse" },
  { label: "GitHub — issues", href: "https://github.com/GoodBetterLLC/pulse/issues" },
  { label: "Infra — lifesuite-infra", href: "https://github.com/GoodBetterLLC/lifesuite-infra" },
  { label: "Infra — gbl-infra", href: "https://github.com/GoodBetterLLC/gbl-infra" },
];
